module.exports = __webpack_public_path__ + "img/855.ca621647.png";